import React from "react";
import PropTypes from "prop-types";
// Material imports
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
const FADE_ANIMATION_TIMEOUT = 800;
const AnimationWrapper = ({
  children,
  showAnimation = false
}) => {
  if (showAnimation) {
    return /*#__PURE__*/React.createElement(Fade, {
      in: true,
      timeout: FADE_ANIMATION_TIMEOUT
    }, /*#__PURE__*/React.createElement(Box, null, children));
  } else {
    return children;
  }
};
AnimationWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  id: PropTypes.string,
  showAnimation: PropTypes.bool
};
export default AnimationWrapper;